import { useState } from 'react';

import { CalendarIcon } from '@assets/icons';
import {
  DateType,
  getCurrentDate,
  isInclusivelyAfterDay,
} from '@utils/dateUtil';
import ResponsiveSearchDrawerItem from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import ResponsiveApplyButton from '@components/views/components/listing/drawer/ResponsiveApplyButton/ResponsiveApplyButton';
import ResponsiveSearchInputDrawer from '@components/views/components/listing/drawer/ResponsiveSearchInputDrawer/ResponsiveSearchInputDrawer';
import { FlightSearchInputDrawerType } from '@components/views/flight/types';
import ResponsiveDateRangePicker from '@components/DatePicker/DateRangePicker/ResponsiveDateRangePicker';
import { DayPickerRangeControllerProps } from '@components/DatePicker/DateRangePicker/DateRangePicker';
import { getDateRangePickerPlaceholder } from '@components/views/flight/listing/SearchBar/DateSelect/utils';

const searchLabel = 'Giriş-Çıkış Tarihiniz?';

const ResponsiveDateRangeSelectDrawer = ({
  startDate,
  endDate,
  onDatesChange,
  title,
  subTitle,
  placeholder,
  drawerTitle,
  arrowIcon,
  inputComponent,
  isSubmit,
}: Pick<
  DayPickerRangeControllerProps,
  'startDate' | 'endDate' | 'onDatesChange'
> &
  FlightSearchInputDrawerType & {
    inputComponent:
      | 'shopAndFlyHomePageFlight'
      | 'shopAndFlyHomePageHotel'
      | 'setur';
  } & { isSubmit?: boolean }) => {
  return (
    <ResponsiveSearchInputDrawer
      icon={CalendarIcon}
      title={title}
      subTitle={subTitle}
      placeholder={placeholder}
      drawerTitle={drawerTitle}
      arrowIcon={arrowIcon}
      inputComponent={inputComponent}
      startDate={startDate}
      endDate={endDate}
      isSubmit={isSubmit}
    >
      {(hideModal) => (
        <ResponsiveDateRangeSelect
          startDate={startDate}
          endDate={endDate}
          onDatesChange={onDatesChange}
          hideModal={hideModal}
        />
      )}
    </ResponsiveSearchInputDrawer>
  );
};

const ResponsiveDateRangeSelect = ({
  startDate,
  endDate,
  onDatesChange,
  hideModal,
}: Pick<
  DayPickerRangeControllerProps,
  'startDate' | 'endDate' | 'onDatesChange'
> & {
  hideModal: () => void;
}) => {
  const [localStartDate, setLocalStartDate] = useState<DateType | null>(
    startDate
  );
  const [localEndDate, setLocalEndDate] = useState<DateType | null>(endDate);

  const handleDatesChange = ({
    startDate,
    endDate,
  }: {
    startDate: DateType | null;
    endDate: DateType | null;
  }) => {
    setLocalStartDate(startDate);
    setLocalEndDate(endDate);
  };

  const localSubTitle = getDateRangePickerPlaceholder(
    localStartDate,
    localEndDate
  );

  const onSubmit = () => {
    if (localStartDate && localEndDate) {
      onDatesChange({ startDate: localStartDate, endDate: localEndDate });
      hideModal();
    }
  };

  return (
    <>
      <ResponsiveSearchDrawerItem
        icon={CalendarIcon}
        title={searchLabel}
        subTitle={localSubTitle}
        placeholder='Giriş - Çıkış Tarihleri'
      />

      <ResponsiveDateRangePicker
        minimumNights={0}
        startDate={localStartDate}
        endDate={localEndDate}
        onDatesChange={handleDatesChange}
        isOutsideRange={(day) => !isInclusivelyAfterDay(day, getCurrentDate())}
      />
      <ResponsiveApplyButton onClick={onSubmit} />
    </>
  );
};

export default ResponsiveDateRangeSelectDrawer;
